import Typography from "@mui/material/Typography";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { styled } from "@mui/material";


export const TabPanel = ({ children, index, value, tabType, ...other }) => {
    if (index === value) {
        return (
            <Box
                // role='tab-panel'
                id={`scrollable-auto-tab-panel-${tabType}-${index}`}
                aria-labelledby={`scrollable-auto-tab-${index}`}
                {...other}>
                {children}
            </Box>
        );
    }
    return null;
};

export const MainContainer = styled('div')(() => ({
    // backgroundColor: '#f4f7fb',
    width: '100%',
}));


export const MainButton = styled(Button)(() => ({
    border: 'none',
    padding: '4px 35px',
    borderRadius: 20,
    fontSize: 12,
    textTransform: 'inherit',
    '&:hover': { border: 'none' },
}))
    ;

export const MoreButton = styled(MainButton)(() => ({
    backgroundColor: "#638dff",
    color: '#FFFFFF',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 12,
    padding: '4px 35px',
    boxShadow: 'none',
    '&:hover': { backgroundColor: "#4c71d6" },
    '&:focus': { boxShadow: '0 0 6px 0 #638dff !important' },
    '&:disabled': {
        backgroundColor: '#aeb8d6',
        color: '#e8ecf8',
    },
}));


export const CancelButton = styled(MainButton)(() => ({
    backgroundColor: '#e0e8ff',
    color: '#638dff',
    border: 'none',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 12,
    padding: '4px 35px',
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#eef2ff' },
    '&:focus': {
        boxShadow: '0 0 6px 0 rgba(99, 141, 255, 0.6)',
        backgroundColor: '#eef2ff',
    },
    '&:disabled': {
        backgroundColor: '#e8ecf8',
        color: '#aeb8d6',
        border: 'none',
    },
}));

// TODO: section form bottom main buttons
export const ConfirmButton = styled(MainButton)(() => ({
    backgroundColor: "#638dff",
    color: '#FFFFFF',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 12,
    padding: '4px 35px',
    boxShadow: 'none',
    '&:hover': { backgroundColor: "#4c71d6" },
    '&:focus': { boxShadow: '0 0 6px 0 #638dff !important' },
    '&:disabled': {
        backgroundColor: '#aeb8d6',
        color: '#e8ecf8',
    },
}));


export const Title = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'userDomain',
})(({ theme, userDomain }) => ({
    margin: theme.spacing(1),
    marginLeft: theme.spacing(0),
    marginTop: theme.spacing(1),
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'Figtree-Regular',
}));


export const AppBarContainer = styled(AppBar)(() => ({
    backgroundColor: 'transparent',
    boxShadow: 'none',
    marginBottom: '33px',
}));


export const TabContainer = styled(Tab, {
    shouldForwardProp: (prop) => prop !== 'userDomain',
})(({ userDomain }) => ({
    textTransform: 'none',
    minWidth: 'fit-content',
    fontSize: '12px',
    padding: '0px 10px',    
    fontFamily: 'Figtree-Regular',
}));


export const ActionContainer = styled(Grid)(
    ({ theme }) => (
        {
            textTransform: 'none',
            width: '55%',
            // width: "fit-content",
            // eslint-disable-next-line no-sequences
        },
        (props) => (props.ismore
            ? { width: '100%' }
            : {
                width: '55%',
                [theme.breakpoints.between('md', 'lg')]: { width: '100%' },
            })
    ),
);